import React from 'react';
import classNames from 'classnames';

export default function SecurityBadgeIconFilled({ className = '' }) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={classNames('icon-safety_and_security--filled', className)}
		>
			<path
				d="M27.65 8.211C27.6366 8.15221 27.611 8.0969 27.5748 8.04866C27.5386 8.00043 27.4927 7.96034 27.44 7.931L16.54 2.011H16.33C16.2743 1.99601 16.2157 1.99601 16.16 2.011L15.607 2.311L6.2 7.4L5.27 7.9C5.25092 7.91233 5.22945 7.9205 5.207 7.924C5.119 7.932 5.081 7.994 5.045 8.073C5.01668 8.13171 5.00133 8.19583 5 8.261V18.191L5.08 18.501C5.21517 19.0261 5.37874 19.5436 5.57 20.051C6.18394 21.7338 7.03594 23.32 8.1 24.761C10.0938 27.4907 12.8908 29.529 16.1 30.591H16.38C22.68 28.471 26.43 24.221 27.56 17.891V8.211H27.65Z"
				fill="black"
			/>
			<path
				d="M22.0001 12.431L14.3301 19.131L10.6601 15.461C10.6143 15.4143 10.5597 15.3771 10.4995 15.3516C10.4392 15.3261 10.3745 15.3128 10.3091 15.3125C10.2436 15.3121 10.1788 15.3248 10.1183 15.3497C10.0578 15.3745 10.0028 15.4112 9.95651 15.4574C9.91024 15.5037 9.87361 15.5587 9.84873 15.6192C9.82384 15.6797 9.8112 15.7445 9.81153 15.81C9.81186 15.8754 9.82516 15.9401 9.85065 16.0003C9.87615 16.0606 9.91333 16.1152 9.96006 16.161L13.9601 20.161C14.0049 20.2088 14.059 20.2469 14.1191 20.273C14.1793 20.2991 14.2445 20.312 14.3101 20.311C14.4307 20.3107 14.5475 20.2683 14.6401 20.191L22.6401 13.191C22.6901 13.1479 22.731 13.0952 22.7605 13.0362C22.79 12.9772 22.8076 12.9129 22.8121 12.847C22.8209 12.7471 22.7994 12.6468 22.7505 12.5592C22.7015 12.4716 22.6274 12.4008 22.5376 12.3559C22.4479 12.3111 22.3467 12.2942 22.2473 12.3076C22.1479 12.321 22.0548 12.364 21.9801 12.431H22.0001Z"
				fill="white"
			/>
		</svg>
	);
}
